// Vistas principales
import Dashboard from "views/Dashboard.js";
import Inversiones from "views/Inversiones.js";
import Ofertas from "views/Ofertas.js";
import Retiro from "views/Retiro.js";
import Movimientos from "views/Movimientos.js";
import Projectos from "views/Projectos";
import UserProfile from "views/UserProfile.js";
import UltraDeposito from "views/DepositosView/Depositos.jsx";
import UserTargetas from "views/Tagetas/UserTargetas";

// Nueva vista para Wallet Blockchain
import WalletBlockchain from "views/WalletBlockchain.js"; // ← Crearemos este componente

// Contextos
// Configuración de rutas principal
const routes = [
  {
    path: "/dashboard",
    name: "Inicio",
    tkey: "nav.inicio",
    icon: "tim-icons icon-bank",
    component: Dashboard,
    layout: "/cliente"
  },
  {
    path: "/movimientos",
    name: "Movimientos",
    tkey: "nav.movimientos",
    icon: "tim-icons icon-notes",
    component: Movimientos,
    layout: "/cliente"
  },
  {
    path: "/projectos",
    name: "Proyectos",
    tkey: "nav.proyectos",
    icon: "tim-icons icon-spaceship",
    component: Projectos,
    layout: "/cliente"
  },
  {
    path: "/inversiones",
    name: "Mis inversiones",
    tkey: "nav.inversiones",
    icon: "tim-icons icon-chart-bar-32",
    component: Inversiones,
    layout: "/cliente",
  },
  {
    path: "/ofertas",
    name: "Mis ofertas",
    tkey: "nav.ofertas",
    icon: "tim-icons icon-chart-pie-36",
    component: Ofertas,
    layout: "/cliente"
  },
  {
    path: "/wallet",  // ← NUEVA RUTA
    name: "Wallet Blockchain",
    tkey: "nav.wallet",
    icon: "tim-icons icon-wallet-43",
    component: WalletBlockchain,
    layout: "/cliente"
  },
  {
    path: "/ultradeposito",
    name: "Depósito",
    tkey: "nav.deposito",
    icon: "tim-icons icon-coins",
    component: UltraDeposito,
    layout: "/cliente"
  },
  {
    path: "/retiro",
    name: "Retiro",
    tkey: "nav.retiro",
    icon: "tim-icons icon-money-coins",
    component: Retiro,
    layout: "/cliente"
  },
  {
    path: "/user-tarjeta",
    name: "Tarjetas",
    tkey: "nav.tarjetas",
    icon: "tim-icons icon-credit-card",
    component: UserTargetas,
    layout: "/cliente"
  },
  {
    path: "/user-profile",
    name: "Mi cuenta",
    tkey: "nav.cuenta",
    icon: "tim-icons icon-single-02",
    component: UserProfile,
    layout: "/cliente"
  },
];

// Rutas pendientes o secundarias (si las necesitas)
const routespen = [
  {
    path: "/user-profile",
    name: "Mi Cuenta",
    tkey: "nav.cuenta",
    icon: "tim-icons icon-single-02",
    component: UserProfile,
    layout: "/cliente"
  },
];

// Exportar rutas principales
export default routes;

// Exportar también las secundarias si se necesitan
export { routespen };